import { StyledHeaderElement } from '../../../../styles/sharedStyles';
import { StyledText } from '../../../atoms/Text/StyledText';
import { StyledSummaryElementData } from '../../../atoms/SummaryEditElement/StyledSummaryElementData';
import { getDateString } from '../../../../logic/eventtime';
import { getLang } from '../../../../strings';

const SummaryEditElementTable = ({
    hour,
    student,
    trainer,
    price,
    price_trainer,
    subjects,
    isAdmin,
}) => {
    return (
        <StyledSummaryElementData>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtextalign="center"
                    hasdeclaredlineheight="1.4em"
                >
                    {student}
                </StyledText>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtextalign="center"
                    hasdeclaredlineheight="1.4em"
                >
                    {getDateString(new Date(hour.date))}
                </StyledText>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtextalign="center"
                    hasdeclaredlineheight="1.4em"
                >
                    {hour.half ? '0.5' : hour.hours}
                </StyledText>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtextalign="center"
                    hasdeclaredlineheight="1.4em"
                >
                    {
                        subjects?.find((el) => el.description && el.id === hour.subject)
                            ?.description[getLang()]
                    }
                </StyledText>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtextalign="center"
                    hasdeclaredlineheight="1.4em"
                >
                    {trainer}
                </StyledText>
            </StyledHeaderElement>
            <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                <StyledText
                    hasdeclaredfontsize="16px"
                    hasdeclaredfontweight="600"
                    hasdeclaredtextalign="center"
                    hasdeclaredlineheight="1.4em"
                >
                    {price.dp() > 0 ? price.toFixed(2) : price.toString()} PLN
                </StyledText>
            </StyledHeaderElement>
            {isAdmin ? (
                <StyledHeaderElement $hasWidth={isAdmin ? '14.2%' : '16.6%'}>
                    <StyledText
                        hasdeclaredfontsize="16px"
                        hasdeclaredfontweight="600"
                        hasdeclaredtextalign="center"
                        hasdeclaredlineheight="1.4em"
                    >
                        {price_trainer.dp() > 0
                            ? price_trainer.toFixed(2)
                            : price_trainer.toString()}{' '}
                        PLN
                    </StyledText>
                </StyledHeaderElement>
            ) : null}
        </StyledSummaryElementData>
    );
};

export default SummaryEditElementTable;
